import React from 'react'
import classNames from 'classnames'

import { Icon } from 'pharmacy/src/display/icon'
import { Subtitle3 } from 'pharmacy/src/typography'

import * as css from './iconWithPopup.scss'
class IconWithPopup extends React.Component {
  constructor(props) {
    super(props)
    this.ref = React.createRef()
  }

  state = {
    opened: false,
  }

  onInfoClick = () => {
    const { onClick } = this.props
    this.setState((state) => ({
      opened: !state.opened,
    }))

    if (onClick) {
      onClick()
    }
  }

  boxClick = () => {
    this.setState({
      opened: false,
    })
  }

  renderBox() {
    const { opened } = this.state
    const { children } = this.props

    if (!opened || !children) {
      return null
    }

    return (
      <div className={css.floatingBox} onClick={this.boxClick}>
        {children}
      </div>
    )
  }

  render() {
    const { iconProps, text, type, className, isChip, chipClassName } =
      this.props

    // Generic presenter: `type` picks the built-in icon + color (the original
    // info/warning treatment). When `isChip` is set the icon+text render inside a
    // pill and the caller supplies `chipClassName` for the chip colors — the
    // component stays unaware of any domain-specific states.
    const icon = type === 'warning' ? 'exclamation-triangle' : 'info-circle'
    const typeIconClass = type === 'warning' ? css.warning : css.info
    // In a chip the icon inherits the chip's text color; otherwise it uses the
    // color tied to `type`.
    const iconClass = isChip ? css.chipIcon : typeIconClass

    return (
      <div ref={this.ref} className={className}>
        <Subtitle3
          onClick={this.onInfoClick}
          className={classNames(css.clickable, {
            [css.chip]: isChip,
            [chipClassName]: isChip && chipClassName,
          })}
        >
          <Icon
            className={classNames(css.icon, iconClass)}
            icon={icon}
            {...iconProps}
          />
          <span className={css.text}>{text}</span>
        </Subtitle3>
        {this.renderBox()}
      </div>
    )
  }
}

export default IconWithPopup
